//@flow
import React from 'react';
import Link from '../../../components/Link';

const config = {
  title: 'Custom',
  subtitle: 'Do you have distributed offices? Want options for different teams? Whatever it is, we have you covered.',
};

const {title, subtitle} = config;

const OfficeCustom = (props:any) => {
  return (
    <div className="office-custom">
      <div className="top">
        <h2>{title}</h2>
        <div className="subtitle">
          {subtitle}
        </div>
      </div>
      <div className="bottom">
        <Link to="/office#office-form">
          <button className="cta button">
            Learn More
          </button>
        </Link>
      </div>
    </div>
  );
};

export default OfficeCustom;
